import { gql } from 'apollo-boost';

export const GET_PUBLIC_CHAT_ACTIONS = gql`
    query GetPublicChatActions($data: GetPublicChatActionsInput) {
        getPublicChatActions(data: $data) {
            id
            ownerUserId
            slashCommand
            label
            description
            scope
            visibility
            promptTemplate
            isActive
            isSystem
            createdAt
            updatedAt
        }
    }
`;
